import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../../components/PageHeader";
import { Link } from "react-router-dom";
import StockTransfersTable from "../../../components/Tables/StockTransfersTable";
import {withRouter} from "react-router-dom";
import withPermissions from "../../../components/WithPermissions";
import ManagementPageHero from "../../../components/ManagementPageHero";

class StockTransfers extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {userPermissions} = this.props;
    const userHasCreatePermission = userPermissions.includes('stock.transfer.create');

    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Stok Transferleri"
                Breadcrumb={[
                  {name: "Stok Yönetimi", navigate: ""},
                  {name: "Transferler", navigate: ""},
                ]}
            />
            <ManagementPageHero
              eyebrow="STOK TRANSFERLERİ"
              title="Depolar arası hareketleri yönetin"
              description="Transfer kayıtlarını kaynak ve hedef depolarıyla birlikte izleyin ve yeni transfer oluşturun."
              actionTo={userHasCreatePermission ? "/stock/transfer-add" : null}
              actionLabel="Yeni transfer"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Stok Transferleri</h2>
                    {userHasCreatePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/stock/transfer-add">Yeni Transfer</Link>
                              </li>
                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}
                  </div>
                  <div className="body">
                    <StockTransfersTable />
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withPermissions(withRouter(connect(mapStateToProps, {})(StockTransfers)));




